var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-view-list-field',{attrs:{"align":"center","is-condensed":_vm.isCondensed,"is-sticky":_vm.isSticky,"field":_vm.field,"filter":_vm.filter}},[_c('core-rating',{staticClass:"rating",attrs:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }